function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 40,
  fill: "#fffbed",
  r: 40
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m65.531 19h-52.062c-1.3636 0-2.469 1.1006-2.469 2.4582v32.0836c0 1.3576 1.1054 2.4582 2.469 2.4582h52.062c1.3636 0 2.469-1.1006 2.469-2.4582v-32.0836c0-1.3576-1.1054-2.4582-2.469-2.4582z",
  fill: "#357495"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m45 65h-10l1.3193-9h7.2793z",
  fill: "#0c5860"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m30.7861 65h18.8911",
  stroke: "#357495",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m68 23h-57v27h57z",
  fill: "#a6d0c9"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  strokeMiterlimit: 10
}, /*#__PURE__*/React.createElement("path", {
  d: "m14.9131 41.7562h48.9153",
  opacity: 0.3,
  stroke: "#0c5860",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.9131 37.0775h48.9153",
  opacity: 0.3,
  stroke: "#0c5860",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.9131 31.4628h48.9153",
  opacity: 0.3,
  stroke: "#0c5860",
  strokeWidth: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "m14.9131 25.8481h48.9153",
  opacity: 0.3,
  stroke: "#0c5860",
  strokeWidth: 0.5
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m44.9963 35.9573h-3.424v11.4136h3.424z",
  fill: "#0c5860"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m41.5725 40.5228h-3.4241v6.8482h3.4241z",
  fill: "#cd546c"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m38.1477 40.5228h-3.4241v6.8482h3.4241z",
  fill: "#f36c47"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m57.469 26.8265h-3.4241v20.5445h3.4241z",
  fill: "#0c5860"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m54.0452 42.8055h-3.4241v4.5655h3.4241z",
  fill: "#cd546c"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m50.6223 45.0881h-3.4241v2.2827h3.4241z",
  fill: "#f36c47"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m32.4407 32.5331h-3.4241v14.8376h3.4241z",
  fill: "#0c5860"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m29.0168 38.24h-3.424v9.1308h3.424z",
  fill: "#cd546c"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m25.592 45.0881h-3.424v2.2827h3.424z",
  fill: "#f36c47"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m14.9131 47.3708h48.9153",
  stroke: "#357495",
  strokeMiterlimit: 10,
  strokeWidth: 0.5
});

function SvgMooc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 80,
    viewBox: "0 0 80 80",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMooc);
export default __webpack_public_path__ + "static/media/mooc.61731a41.svg";
export { ForwardRef as ReactComponent };